import {useEffect, useMemo} from 'react';
import {useParams} from 'react-router-dom';

import {CUSTOM_LOGIN_PATHS, RESTRICTED_APP_KEYWORD, ROUTE_URLS} from '../../../constants/routes';
import {SELF_REGISTRATION_TYPES} from '../../../constants/self-registration';
import useFederatedSignIn from '../../../hooks/services/authentication/useFederatedSignIn';
import useSelfRegistrationPoliciesExists from '../../../hooks/services/self-registration/useSelfRegistrationPoliciesExist/useSelfRegistrationPoliciesExists';
import {basename} from '../../../services/history';

/**
 * This CLIENT_URL_STRING_PATTERN matches the same character classes: a-z A-Z and digits,
 * as const patternAntdExcludeSpecialChars = /^[a-zA-Z\d-_]+$/;
 * 
 * The differences are intentional:
 * 
 * in the existing AntD regex means "one or more, any length".
 * but in this case {1,50} means "from 1 to 50 chars", exactly matching input’s `maxLength: 50` from `ClientUrlStringTextInput`.

 * So CLIENT_URL_STRING_PATTERN should be even stricter check
 */
const CLIENT_URL_STRING_PATTERN = /^[A-Za-z0-9_-]{1,50}$/;

const getClientLoginUrl = (clientUrlString) => {
  if (CLIENT_URL_STRING_PATTERN.test(clientUrlString) && clientUrlString.toLowerCase() !== RESTRICTED_APP_KEYWORD) {
    return `/${clientUrlString}/${CUSTOM_LOGIN_PATHS.LOGIN}`;
  }

  return ROUTE_URLS.LOGIN;
};

const ProviderNameRedirectPage = () => {
  const {providerName, client_url_string} = useParams();
  const federatedSignIn = useFederatedSignIn();

  const providerNameFilter = useMemo(() => {
    return {
      providerName,
      type: SELF_REGISTRATION_TYPES.FSSO,
    };
  }, [providerName]);

  const {results: providerNameResults, error} = useSelfRegistrationPoliciesExists(providerNameFilter);

  useEffect(() => {
    if (providerNameResults || error) {
      if (providerName && providerNameResults?.exists) {
        federatedSignIn(providerName);
      } else if (client_url_string) {
        window.location.href = getClientLoginUrl(client_url_string);
      } else {
        window.location.href = `${basename}${ROUTE_URLS.LOGIN}`;
      }
    }
  }, [federatedSignIn, providerName, providerNameResults, client_url_string, error]);

  return <></>;
};

export default ProviderNameRedirectPage;
